import React from "react"

import FieldProto_ConditionForm from "../../../proto/render/condition/condition-form"
import ConditionTypeSelector from "../../../proto/render/condition/condition-type-selector"
import SelectMultiGenericNew from "../../../../gd-ui/select-multi-generic-new/select-multi-generic-new"
import PriorityMultiselectValueNotEmpty from "../components/multiselect/value-not-empty"
import PriorityMultiselectPopoverOption from "../components/multiselect/popover-option"

const debug = false
// const debug = "FieldPriority_ConditionForm"

export default class FieldPriority_ConditionForm extends FieldProto_ConditionForm {

    render() {
        debug && console.log(debug, 'render', this.state)

        return (
            <React.Fragment>
                <ConditionTypeSelector field    = {this.props.field}
                                       value    = {this.props.condition.type}
                                       onChange = {this.onChangeType}/>

                <SelectMultiGenericNew className                        = "selector w-250 m-l-10"
                                       options                          = {this.props.field.getOptions()}
                                       values                           = {this.props.condition.value}
                                       popoverScrollContainerClasses    = "max-h-200 max-w-300"
                                       valueComponent                   = {PriorityMultiselectValueNotEmpty}
                                       popoverOptionComponent           = {PriorityMultiselectPopoverOption}
                                       isSearchable                     = {true}
                                       // disabled                         = {disabled}
                                       onChange                         = {this.onChangeValue}/>
            </React.Fragment>
        )
    }
}
